export default __webpack_public_path__ + "static/media/greendumbbells.11e72222.png";